/* Fila de videos + modal */
(function () {
  function init(root) {
    if (root.dataset.mlbvReady === '1') return;
    root.dataset.mlbvReady = '1';

    var rail = root.querySelector('[data-mlbv-rail]');
    var prev = root.querySelector('[data-mlbv-prev]');
    var next = root.querySelector('[data-mlbv-next]');

    function step() {
      var item = rail && rail.querySelector('.mlbv__item');
      return item ? (item.getBoundingClientRect().width + 10) * 2 : 280;
    }

    function sync() {
      if (!rail || !prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (rail) rail.addEventListener('scroll', sync, { passive: true });
    sync();

    var modal = document.querySelector('[data-mlbv-modal]');
    var player = modal && modal.querySelector('[data-mlbv-player]');

    function close() {
      if (!modal || !player) return;
      player.pause();
      player.removeAttribute('src');
      player.load();
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    root.querySelectorAll('[data-mlbv-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.dataset.src;
        if (!src || !modal || !player) return;
        player.src = src;
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var p = player.play();
        if (p && p.catch) p.catch(function () {});
      });
    });

    if (modal && !modal.dataset.mlbvBound) {
      modal.dataset.mlbvBound = '1';
      modal.querySelectorAll('[data-mlbv-close]').forEach(function (b) {
        b.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mlbv]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
